
function manageSubscription(data){
  
  let listHtml='';
  data.lists.forEach((item,index) =>{
    listHtml+=`
      <tr align="left" id="list-name-box-css">
        <td>
          <ul id="unordered-list-css">
            <li><input type="checkbox" name="lists[]" id="lists_" value="${data.lists[index].id}" checked="checked">${data.lists[index].name}</li>
            <i style="font-size:12px; font-family:monospace;">${data.lists[index].description ? '('+data.lists[index].description+')': ''}</i>
          </ul>
        </td>
        <td id="subscribed-text-css">Subscribed</td>
      </tr>
      `
  })

  return `
  <form action="${data.form_url}" accept-charset="UTF-8" method="post">
  <table cellpadding='10' cellspacing='10' width='100%'>
    <tr>
      <td id='dotted-line-css'></td>
    </tr>
    <tr>
      <td>
        <h3 id='radio-button-1-text-css'>
          <input type="radio" name="unsubscribe" id="unsubscribe_list" value="list" checked="checked" />
          ${data.translations['unsubscribe_text_line3']}
        </h3>
      </td>
    </tr>
    ${data.campaign.brand_id && listHtml || ''}
    <tr>
      <td id='dotted-line-css'></td>
    </tr>
    <tr>
      <td>
        <h3 id='radio-button-2-text-css'>
          <input type="radio" name="unsubscribe" id="unsubscribe_all_lists" value="all_lists" />
          ${data.translations['unsubscribe_text_line4']}
        </h3>
        <p id='future-mail-text-css'>${data.translations['unsubscribe_text_line5']}</p>
      </td>
    </tr>
    ${!data.campaign.brand_id && listHtml || ''}
    <tr>
      <td id='dotted-line-css'></td>
    </tr>
    <tr>
      <td>
        <h3 id='radio-button-2-text-css'>
          <input type="radio" name="unsubscribe" id="unsubscribe_global" value="global" />
          ${data.translations['unsubscribe_text_line6']}
        </h3>
        <p id='future-mail-text-css'>${data.translations['unsubscribe_text_line7'].replace('(','').replace(')','').replace(/<br>/g,'')}</p>
      </td>
    </tr>
    <tr>
      <td id='dotted-line-css'></td>
    </tr>
    <tr>
      <td id='submit-btn-css'><input type="submit" name="commit" value="${data.translations['update_button_text']}" data-disable-with="Update" /></td>
      <td id='edit-profile-link-css'><a href="/a/${data.campaign.account_id}/edit_profile/${data.campaign.id}/${data.contact.id}/${"data.params['security_key']"}">${data.translations['mail_footer_manage_preferences']}</a></td>
    </tr>
  </table>
</form>
  `;
}

function editProfile(data){
  let htmlPart =
    `<form class="new_contact" id="new_contact_1" action="${data.form_url}" accept-charset="UTF-8"
      method="post">
      <table cellpadding="0" cellspacing="5" id="edit-profile-table-css" style="white-space:nowrap">
        <tbody>
        <tr>
          <td>Email</td>
          <td><input type="text" name="contact[email]" id="contact_email"></td>
        </tr>
        <tr>
          <td>First Name</td>
          <td><input type="text" value="" name="contact[first_name]" id="contact_first_name"></td>
        </tr>
        <tr>
          <td>Last Name</td>
          <td><input type="text" value="" name="contact[last_name]" id="contact_last_name"></td>
        </tr>`;
  data.custom_fields.forEach(field =>{
    htmlPart += 
    `<tr>
      <td>
        <label for="custom_field_${field.name}: ">${field.display_name}</label>
      </td>
      <td>
        <input
          id="custom_field_${field.name}"
          type="${field.type}"
          name="custom_field[${field.name}]"
          include_blank="true"
          value=""
        >
      </td>
    </tr>`
  })
  htmlPart += 
    `<tr>
      <td colspan="2">
        <p>
          <label id="stop-future-emails-text-css">
            <input name="unsubscribe[global]" type="hidden" value="no"><input type="checkbox" value="yes"
              name="unsubscribe[global]" id="unsubscribe_global">
          ${data.translations['unsubscribe_text_line6']}
          </label>
        </p>
        <p id="stop-future-emails-text-message-css">${data.translations['unsubscribe_text_line7']}</p>
      </td>
    </tr>
    </tbody>
    </table>
    <p><input type="submit" name="commit" value="${data.translations['update_button_text']}" data-disable-with="${data.translations['update_button_text']}"></p>
    </form>
    <style>input { border: 1px solid #767676 !important} @media only screen and (max-width: 400px) {
      form {display:block !important;} }</style>
    `
  return htmlPart;
}

function reportSpam(data){
  return `<form action="${data.form_url}" accept-charset="UTF-8" method="post">
    <label id='checkbox-css'>
      <input name="unsubscribe[spam]" type="hidden" value="no" />
      <input type="checkbox" value="yes" name="unsubscribe[spam]" id="unsubscribe_spam" />
      ${data.translations['mail_header_report_spam']}
    </label>
    <br>
    <br>
    <p id='submit-button-css'><input type="submit" name="commit" value="${data.translations['report_spam_submit_button']}" data-disable-with="Submit" /></p>
  </form>`
}

function oneClickUnsubscribe(data){
  return `
    <form action="${data.form_url}" accept-charset="UTF-8" method="post">
    <input value="yes" type="hidden" name="unsubscribe[one_click_unsub]" id="unsubscribe_one_click_unsub" />
    <br>
      <p id='submit-button-css'>
        <input type="submit" name="commit" value="${data.translations['one_click_unsub_button_text']}" data-disable-with="${data.translations['one_click_unsub_button_text']}" />
      </p>
    </form>
  `;
}

export function parsedHtml(htmlString, data){
  let outputHtml = htmlString;
  //{{report_spam.form}} 
  const tagRegex = /{{(.*?)}}/g;

  // Find tags in the HTML string
  const foundTags = htmlString.match(tagRegex);

  // Remove {{ }} and trim whitespace from each tag
  const formattedTags = foundTags.map(tag => tag.replace(/{{|}}/g, '').trim());
    // Convert the array of formatted tags to a Set to remove duplicates
  const uniqueFormattedTags = [...new Set(formattedTags)];
  uniqueFormattedTags.map(tag =>{
    const content = fetchContent(tag, data);
    outputHtml = replaceTagWithString(outputHtml, tag, content);
    
  })

  return outputHtml
}

function fetchContent(tag, data) {
  switch(tag){
    case 'report_spam.form':
    return reportSpam(data);
    case 'manage_sub.form':
      return manageSubscription(data);
    case 'edit_profile.form':
      return editProfile(data)
    case 'one_click_unsub.form':
      return oneClickUnsubscribe(data)
    case 'contact.email':
      return data.contact && data.contact.email || `{{${tag}}}`;
    default:
      return `{{${tag}}}`
  }
}

function replaceTagWithString(inputString, tag, replacement) {
  // Construct a regular expression to match the tag
  const regex = new RegExp(`{{\\s*${tag}\\s*}}`, 'g');
  
  // Replace all occurrences of the tag with the replacement value
  const resultString = inputString.replace(regex, replacement);
  
  return resultString;
}